import { getRightsData } from "../../Tools/Tools";
import { parseColumns } from "../GridTools/parseColumnTools";
import { createGrid, createRecordSource } from "../rcsgrid";
import { Prefixes } from "../../Tools/ProjectX";
import smetaAxios from "../../../SmetaAxios";
import { RefObject } from "react";

export async function transactGrid(grid: createGrid, source: createRecordSource, props: { path: string }, data) {
  source.onHandleRequest = handleRequest(props.path, source, data.fullDocNamesVisibleRef, data.fullDocNamesCheckedRef);
  const tableLayout = data.tableLayout;

  if (tableLayout) {
    const rights = Number(tableLayout.Rights) || 0;
    const readOnly = tableLayout.ReadOnly === "1" || rights === 0;
    //TODO cgTable.ReadOnly := True;
    source.rights = getRightsData(rights);

    const columns = parseColumns(tableLayout, {
      Path: props.path,
      Module: Prefixes.acc,
    });

    if (columns.title.length) {
      columns.title[0].fieldInfo.options.fixed = true;

      for (const column of columns.title) {
        const { fieldName, fieldInfo } = column;

        if (fieldName === "C_Analitika" || fieldName === "D_Analitika") {
          //TODO Column.OnCreatePopupControl := onCreatePopupAnalytic;
        } else if (readOnly) {
          fieldInfo.EditStyle = "";
        }

        if (fieldName === "Document") {
          fieldInfo.options.link = true;
        }
      }
    }

    grid.setColumns(columns);
    grid.columns.title[0].sortDirect = "up";
  } else {
    grid.defaultColumns = true;
  }

  grid.setImageFields(["ParentID"]);
  source.booksGetImage = (value) => {
    if (Number(value) !== 0) return 106;
    return "";
  };

  if (data.onMultiSelectChange) grid.onMultiSelectChange = data.onMultiSelectChange;
  await source.open();
  await source.orderRecords("OpDate");
  await grid.setSource(source);

  if (data.setSelectedRecord) {
    source.onRecordIndexChanged = async (source) => {
      data.setSelectedRecord(source.getFieldTextSync("ID"));
    };
    data.setSelectedRecord(source.getFieldTextSync("ID"));
  }
  await grid.updateGridSize();
}

const handleRequest = (
  path: string,
  source: createRecordSource,
  fullDocNamesVisibleRef: RefObject<boolean>,
  fullDocNamesCheckedRef: RefObject<boolean>,
) => {
  return (request) => {
    return smetaAxios.post("HandleTable", request, {
      prefix: Prefixes.acc,
      params: {
        Path: path,
        RecordIndex: source.activeRecord,
        optim: fullDocNamesVisibleRef.current ? (fullDocNamesCheckedRef.current ? "1" : "2") : undefined,
      },
      loadMask: true,
    });
  };
};
